export default __webpack_public_path__ + "static/media/website-09 1.167aaaf2.png";